var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1707478226(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1558,
    cy: 16,
    r: 16,
    fill: "#F0EAFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1558,
    cy: 16,
    r: 15.619,
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.761905
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.9683 11.3367L15.2552 15.9995L19.9683 20.6624L18.5102 22.0948L12.3493 15.9995L18.5102 9.9043L19.9683 11.3367Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1707478226);
export default __webpack_public_path__ + "static/media/Group 1707478226.df495bbc5dfb92278970b44191402756.svg";
export { ForwardRef as ReactComponent };